<template lang="pug">
  div.p-5(v-if="!block || block.empty")
    b-card.mb-0.card-inactive
      p.mb-0.text-help.text-center No se ha seleccionado bloque
  div.p-3.mb-5(style="position:relative;", v-else)
    p.mb-1.text-sm.text-secondary Bloque ID: {{  block.block_id }}
    b-form-group(label="Nombre de bloque:")
      b-input-group
        b-form-input(v-model="block.name", placeholder="Nombre de bloque", @input="updateBlock")
        b-input-group-append
          b-button(variant="soft-secondary", @click="updateBlock", :disabled="loading_block")
            b-spinner(variant="primary", v-if="loading_block", small)
            save-icon.icon-md(v-else)
    b-tabs.mb-4(v-model="tabIndex")
      b-tab(title="Templates")
      b-tab(title="Configuración")
    div(v-show="tabIndex == 0")
      b-form-group.mb-5(description="Se guardará el título de un botón, título de respuesta rápida o el texto introducido por el usuario en esta variable.")
        p.mb-2.text-sm Guardar respuesta del usuario en la variable:
        k-select.disabled-white(placeholder="- No guardar -", :options="parsedUserAttributes", :value="block.user_attribute_id || null", :clearable="true", @input="updateBlock({user_attribute_id: $event})")
      block(v-bind="block", :disabled="false")
      .templates-bar
        .template(v-for="template in templates.filter(t => t.info.basic)", :key="template.type", @click="createTemplate(template.type)")
          component.icon-sm.mb-2(:is="template.info.icon")
          span.text-sm(v-for="(line, line_index) in template.info.name.split(' ')", :key="line_index") {{ line }}
        .template(@click="createTemplate(addTemplate.type)")
          component.icon-sm.mb-2(:is="addTemplate.info.icon")
          span.text-sm(v-for="(line, line_index) in addTemplate.info.name.split(' ')", :key="line_index") {{ line }}
    div(v-show="tabIndex == 1")
      b-list-group.mb-3
        b-list-group-item
          b-row
            b-col
              p.mb-2 Marcar bloque como importante
              p.text-secondary.text-sm.mb-0 Los bloques importantes aparecen en las conexiones a bloques dentro del dashboard
            b-col(cols="auto")
              b-form-checkbox(switch, v-model="block.is_important", @change="updateBlock")
        b-list-group-item
          b-row.align-items-center
            b-col
              p.mb-2 Eliminar bloque
              span.text-help.text-sm Esta acción no se puede deshacer. Las conexiones que llegaban a este bloque dejarán de funcionar.
            b-col.mt-3.mt-md-0(md="auto")
              b-button(variant="soft-danger", @click="$emit('delete')", :block="$breakpoint.smDown") Eliminar bloque
    b-modal(v-model="templatesListModal", size="lg", title="Crear template", hide-footer, @hidden="searchTemplate = ''")
      b-container
        b-form-group
          b-input-group
            b-form-input(placeholder="Buscar template...", v-model="searchTemplate")
            b-input-group-append
              b-input-group-text
                search-icon.icon-sm
        b-row
          b-col(sm="6", lg="4", v-for="(template, template_index) in Templates", :key="template.type")
            b-card.text-center.pointer.no-shadow.template-hover(@click="createTemplate(template.type)")
              .d-flex.align-items-center.justify-content-center.flex-column.mb-3
                v-icon.icon-md.mb-2(:name="template.info.icon", v-if="template.info.icon.includes('brands/')")
                component.icon-md.mb-2(:is="template.info.icon", v-else)
                span {{ template.info.name }}
              p.text-sm.mb-2(v-for="(line, line_index) in template.info.description.split('.')", :class="line_index == 0 ? 'text-secondary' : 'text-help'") {{ line }}
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import { templates } from '@/data/templates'

import Block from '@/components/templates/Block.vue'
import Select from '@/components/Select.vue'
import { EventBus } from '@/helpers/eventBus'

import _debounce from 'lodash.debounce'

const accountController = createNamespacedHelpers('account')
const platformController = createNamespacedHelpers('platform')
const flowController = createNamespacedHelpers('flow')
const blockController = createNamespacedHelpers('block')
const templateConnectorController = createNamespacedHelpers('template_connector')

export default {
  data () {
    return {
      loading_block: false,
      tabIndex: 0,
      templatesListModal: false,
      templates: templates,
      addTemplate: {
        type: 'add',
        info: {
          name: 'Más',
          description: '',
          icon: 'plus-icon'
        }
      },
      fields: [
        {
          key: 'info',
          label: 'Template'
        }
      ],
      searchTemplate: ''
    }
  },
  props: {
    block: {
      type: Object,
      default: function () {
        return {
          empty: true
        }
      }
    },
    platform: {
      default: 'all'
    }
  },
  computed: {
    ...accountController.mapGetters(['selectedLanguage', 'selectedLocale', 'selectedLanguageName']),
    ...accountController.mapState({
      user_attributes: state => state.user_attributes
    }),
    ...platformController.mapState({
      platforms: state => state.platforms
    }),
    parsedUserAttributes () {
      return this.user_attributes.map(a => {
        return {
          label: a.name,
          id: a.user_attribute_id
        }
      })
    },
    Templates () {
      if (!this.searchTemplate) return this.templates
      return this.templates.filter(t => {
        return (new RegExp(this.searchTemplate, 'i').test(`${t.info.name} ${t.info.description}`))
      })
    }
  },
  methods: {
    ...mapActions(['block/update', 'account/userAttributes', 'template/create']),
    getUserAttributes () {
      let self = this

      this['account/userAttributes']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            console.error(res.error)
          }
        }
      })
    },
    createTemplate (type) {
      let self = this

      if (this.templatesListModal) this.templatesListModal = false

      if (type == 'add') {
        this.templatesListModal = true
        return
      }

      let template = this.templates.find(t => t.type == type)

      let template_platforms = []
      if(this.block.Templates.length){
        template_platforms = this.block.Templates[this.block.Templates.length-1].Platforms.map(p => p.platform_id)
      } else if(this.platform != 'all') {
        let plat = this.platforms.find(p => p.name == this.platform);
        if(plat) template_platforms.push(plat.platform_id)
      } /*else {
        template_platforms = this.platforms.map(p => p.platform_id)
      }*/

      this['template/create']({
        language_id: self.selectedLanguage,
        block_id: self.block.block_id,
        ...template,
        number: self.block.Templates.length + 1,
        platforms: template_platforms,
        callback: async (res) => {
          if (res.error) {
            let res = await this.$bvModal.msgBoxConfirm('Ocurrió un error creando template. ¿Deseas intentarlo de nuevo?', {
              title: 'Error creando',
              okVariant: 'primary',
              okTitle: 'Reintentar',
              cancelTitle: 'Cancelar',
              cancelVariant: 'secondary',
              hideHeaderClose: false
            })

            if (res) {
              this.createTemplate.apply(this, arguments)
            }
          }
        }
      })
    },
  },
  created () {
    this.updateBlock = _debounce((data = {}) => {
      let self = this
      this.loading_block = true
      let block = {
        name: self.block.name,
        is_important: self.block.is_important
      }

      if (data.user_attribute_id) {
        block.user_attribute_id = data.user_attribute_id
      }

      this['block/update']({
        account_id: self.$route.params.account_id,
        block_id: self.block.block_id,
        ...block,
        language_id: self.selectedLanguage,
        callback: res => {
          self.loading_block = false

          if (res.error) {
            this.$message.error(res.error)
          } else {
            this.$message.success('Bloque actualizado')
          }
        }
      })
    }, 500, {leading: false, trailing: true})
  },
  mounted () {
    this.getUserAttributes()
  },
  components: {
    Block,
    'k-select': Select
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/colors.scss';

  .templates-bar {
    display: flex;
    background-color: $message-bg-light;
    border-radius: 1rem;
    align-items: stretch;
    margin-top: 2rem;
    margin-bottom: .5rem;

    .template {
      flex: 1 0 16.66%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-flow: column;
      cursor: pointer;
      padding: 10px 5px;

      &:hover {
        color: $primary;
        background-color: $message-bg;
      }

      &:not(:first-child) {
        border-left: 1px solid #fff;
      }

      &:first-child {
        border-top-left-radius: 1rem;
        border-bottom-left-radius: 1rem;
      }

      &:last-child {
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
      }
    }
  }

  .template-hover:hover {
    border: 1px dashed $primary;
    color: $primary;
  }
</style>
